import React, { Suspense, useCallback } from "react";
import { useLazyLoadQuery } from "react-relay";
import { graphql } from "relay-runtime";
import { LazyQueryNetworkBoundrary } from "../../../../components/mobile/QueryNetworkBoundrary";
import { TeamScheduleNewQuery } from "./__generated__/TeamScheduleNewQuery.graphql";

import { TeamScheduleComponent } from "./TeamScheduleComponent";
import { RouteProp } from "@react-navigation/native";
import { Layout } from "arkh";
import { ActivityIndicator, View } from "react-native";
import { useBackgroundColor } from "./useBackgroundColor";
import {
  TeamHomeStackNavigationProp,
  TeamHomeStackParamList,
} from "../TeamHomeStack";

export type TeamScheduleProps = {
  teamId: string;
  paddingTop: keyof Layout["space"];
  onRequestNow(c: () => void): () => void;
  onOpenHistory(currentId: string, freq: "DAILY" | "MONTHLY" | "WEEKLY"): void;
  focusFrequency?: "DAILY" | "MONTHLY" | "WEEKLY";
};

function InnerTeamSchedule(props: TeamScheduleProps & { fetchKey: string }) {
  const data = useLazyLoadQuery<TeamScheduleNewQuery>(
    graphql`
      query TeamScheduleNewQuery($teamId: ID!) {
        store {
          id
          team(id: $teamId) {
            color
            ...TeamScheduleComponent_team
          }
        }
      }
    `,
    {
      teamId: props.teamId,
    },
    { fetchKey: props.fetchKey, fetchPolicy: "store-and-network" }
  );
  const bgColor = useBackgroundColor(data.store.team?.color ?? null);

  return data.store.team ? (
    <Suspense
      fallback={
        <View
          style={{
            backgroundColor: bgColor,
            flex: 1,
            justifyContent: "center",
          }}
        >
          <ActivityIndicator color={data.store.team?.color ?? "#FFF"} />
        </View>
      }
    >
      <TeamScheduleComponent
        {...props}
        focusFrequency={props.focusFrequency}
        team={data.store.team}
      />
    </Suspense>
  ) : null;
}

export function TeamSchedule(props: TeamScheduleProps) {
  return (
    <LazyQueryNetworkBoundrary newFetchKeyOnNavigation>
      {(fetchKey) => <InnerTeamSchedule {...props} fetchKey={fetchKey} />}
    </LazyQueryNetworkBoundrary>
  );
}

export function TeamScheduleScreen(props: {
  navigation: TeamHomeStackNavigationProp<"TeamSchedule">;
  route: RouteProp<TeamHomeStackParamList, "TeamSchedule">;
}) {
  const onOpenHistory = useCallback(
    (currentId: string, freq: "DAILY" | "MONTHLY" | "WEEKLY") => {
      props.navigation.navigateDeprecated("TeamScheduleHistory", {
        teamId: props.route.params.teamId,
        freq,
        currentId,
      });
    },
    [props.navigation, props.route.params.teamId]
  );

  return (
    <TeamSchedule
      paddingTop="small"
      teamId={props.route.params.teamId}
      onOpenHistory={onOpenHistory}
      focusFrequency={props.route.params.focusFrequency}
      onRequestNow={noOp} // props.navigation.addListener("tabPress", c)}
    />
  );
}

function noOp() {
  return () => {};
}
